import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Button, IconButton } from '@hyperflake/react-ui-library';
import { PlusIcon } from '@icon/index';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { SiteRecceList } from 'modules/site-recce/components/SiteRecceList/SiteRecceList';
import { Link, useNavigate, useParams } from 'react-router-dom';

const SiteReccePage = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();

    return (
        <PageTemplate>
            <div className="flex justify-between">
                <PageHeading>Recce List</PageHeading>

                {hasPermission(PermissionEnum.SITE_RECCE_CREATE) && (
                    // <Button onClick={addClientDialog.show}>Add Client</Button>
                    <Link
                        to={`/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/recce/add`}
                    >
                        <Button
                            onClick={() =>
                                navigate(
                                    `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/recce/add`
                                )
                            }
                        >
                            Add Recce
                        </Button>
                    </Link>
                )}
            </div>

            <SiteRecceList />
        </PageTemplate>
    );
};

export default SiteReccePage;
